import { ArrowRight } from "lucide-react";

/**
 * Opening pitch: quiet eyebrow, large ink headline with the key phrase
 * in the Vaulzo accent, then the two auth CTAs.
 */
export default function LandingHero({ onOpenAuth }) {
  return (
    <section className="mx-auto max-w-[800px] px-6 pb-16 pt-16 text-center sm:pb-20 sm:pt-24">
      <div className="mb-5 text-[12px] uppercase tracking-[0.14em] text-vaulzo-fainter">
        Personal wealth, one calm dashboard
      </div>

      <h1 className="text-balance text-[40px] font-bold leading-[1.05] tracking-[-0.035em] text-vaulzo-ink sm:text-[56px]">
        Know your net worth.
        <br />
        <span className="text-vaulzo-accent">Grow with clarity.</span>
      </h1>

      <p className="mx-auto mt-6 max-w-lg text-pretty text-[17px] leading-relaxed text-vaulzo-muted">
        Track assets and liabilities, see allocation across categories, and watch
        trends over time — without spreadsheet chaos or bank-app clutter.
      </p>

      {/* One door: the auth page signs you in or creates your account */}
      <div className="mt-10 flex justify-center">
        <button
          type="button"
          onClick={() => onOpenAuth()}
          className="inline-flex h-12 min-w-[220px] items-center justify-center gap-2 rounded-lg bg-vaulzo-accent px-7 text-[15px] font-semibold text-white transition-colors hover:bg-vaulzo-accent-hover"
        >
          Open Vaulzo
          <ArrowRight className="h-4 w-4" strokeWidth={2} />
        </button>
      </div>

      <p className="mt-6 text-[12px] text-vaulzo-subtle">
        Sign in or create an account · Free to start · No credit card
      </p>
    </section>
  );
}
